/**
 * Cookie options shared across any cookies for tracking which the edge
 * middleware needs to read. These options are set to ensure the cookies are
 * accessible on first ingress from an external site.
 */
export const trackingCookieOptions = {
  // "lax" allows the middleware to read the cookies on first-party requests
  sameSite: "lax",
  path: "/",
};
